









import { Component, Vue } from 'vue-property-decorator'
import {AccountFriendsModuleStoreModule} from "@/store";
import {AccountFriendsModuleGetterTypes} from "@/store/modules/account/friends/types";
import {StoreNamespace} from "@/store/types";
import {Getter} from "vuex-class";
import {IAccountEntity} from "@/core/accounts/account.entity";
import CircularLoading from "@/components/Loading/CircularLoading.vue";

@Component({
  components: {CircularLoading}
})
export default class InvitationCodeInfo extends Vue {
  @Getter(AccountFriendsModuleGetterTypes.INVITED_BY_ACCOUNT, { namespace: StoreNamespace.AccountFriends })
  private readonly invitedByAccount!: IAccountEntity | null

  private isNotFound: boolean = false

  private async created() {
    if (this.invitedByAccount !== null) {
      if (this.invitedByAccount.invitation_code !== this.$route.query.invitation_code) {
        await this.setInvitedAccountByInviteCode()
      }
    } else {
      await this.setInvitedAccountByInviteCode()
    }
  }

  private async setInvitedAccountByInviteCode () {
    const setInvitedAccountByInviteCodeResult = await AccountFriendsModuleStoreModule.setInvitedAccountByInviteCode(
        this.$route.query.invitation_code as string)

    if (!setInvitedAccountByInviteCodeResult.isSuccess()) {
      this.isNotFound = true
      AccountFriendsModuleStoreModule.removeInvitedByAccount()
      AccountFriendsModuleStoreModule.removeInvitationCode()
    }
  }
}
